import { useContext, useEffect } from "react";
// import { CartContext } from '../../context/CartContext';
import { Link } from "react-router-dom";
import { Context } from "../../context/ContextProvider";

import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import Badge from "@mui/material/Badge";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

const CartWidget = () => {
  const { amountOfItemsInCart, newList, cartItmes, numberInCart } =
    useContext(Context);
  // const numbers = [15.5, 2.3, 1.1, 4.7];
  const cartFull =
    cartItmes?.length > 0
      ? cartItmes
          .map((item) => item.qty)
          .reduce((previous, item) => previous + item, 0)
      : 0;
  // const cartFull =
  //   localStorage.getItem("Order") != null
  //     ? JSON.parse(localStorage.getItem("Order"))
  //         .map((item) => item.qty)
  //         .reduce((previous, item) => previous + item, 0)
  //     : cartItmes?.length > 0
  //     ? cartItmes
  //         .map((item) => item.qty)
  //         .reduce((previous, item) => previous + item, 0)
  //     : 0;

  // const cartFull =
  //   cartItmes?.length > 0
  //     ? cartItmes
  //         .map((item) => item.qty)
  //         .reduce((previous, item) => previous + item, 0)
  //     : localStorage.getItem("Order") != null
  //     ? JSON.parse(localStorage.getItem("Order"))
  //         .map((item) => item.qty)
  //         .reduce((previous, item) => previous + item, 0)
  //     : 0;

  // const cartFull =
  //   localStorage.getItem("Order") != null
  //     ? JSON.parse(localStorage.getItem("Order"))
  //         .map((item) => item.qty)
  //         .reduce((previous, item) => previous + item, 0)
  //     : 0;

  // useEffect(() => {
  // console.log("count in cart: ", cartFull,localStorage.getItem("CountCart"));
  // localStorage.setItem("CountCart", cartFull)
  // localStorage.setItem("CountCart", 0)
  // cartFull.length > 0 && localStorage.setItem("CountCart", cartFull);
  // }, [cartItmes]);

  return 1 > 0 ? (
    <Tooltip title="">
      <IconButton
        sx={{ mx: 1 }}
        aria-label="carrito"
        size="medium"
        color="inherit"
        component={Link}
        onClick={() =>
          cartFull !== 0 && localStorage.setItem("CountCart", cartFull)
        }
        to="/cart"
      >
        <Badge
          badgeContent={
            // localStorage.getItem("CountCart") != null || localStorage.getItem("CountCart") !== 0
            //   ? localStorage.getItem("CountCart")
            //   :
            cartFull === 0 ? localStorage.getItem("CountCart") : cartFull
            // localStorage.getItem("CountCart")
          }
          color="error"
        >
          <ShoppingCartIcon sx={{ fontSize: 20 }} />
        </Badge>
      </IconButton>
    </Tooltip>
  ) : null;
};

export default CartWidget;
